import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import HtmlEmbed from "@components/ContentEditorView/HtmlEmbed";
import Heading from "@components/Heading";
import SellerReviews from "@components/Seller/SellerReviews";
import Accordion from "@components/Accordion";
import AccordionItem from "@components/Accordion/Item";
import AccordionItemHeader from "@components/Accordion/Item/Header";
import AccordionItemBody from "@components/Accordion/Item/Body";
import Ratings from "@components/Ratings";
import { getSlug } from "@lib/helpers";

const SellerTabs = ({
  reviewsSummary,
  seller: {
    id,
    description,
    shipping_info,
    rma_info,
    warranty_info,
    customer_confidentiality_info,
  },
}) => {
  const { asPath } = useRouter();
  const [openedSection, setOpenedSection] = useState("");

  useEffect(() => {
    const hash = asPath.split("#")[1];

    if (hash) {
      const hashSlug = getSlug(hash);
      const sectionElement = document.getElementById(hashSlug);

      if (sectionElement) {
        setOpenedSection(hashSlug);
      }
    }
  }, []);

  useEffect(() => {
    if (openedSection) {
      const sectionElement = document.getElementById(openedSection);
      sectionElement.scrollIntoView();
    }
  }, [openedSection]);

  const reviewsCount = reviewsSummary?.items[0]?.reviews?.value ?? 0;
  const reviewsScore = reviewsSummary?.items[0]?.reviews?.total ?? 0;
  const reviewAverage =
    Math.round((reviewsScore / reviewsCount + Number.EPSILON) * 100) / 100;

  const onAccordionItemToggle = ({ item, expanded }) =>
    history.replaceState({}, "", `#${expanded ? item : ""}`);

  return (
    <div className="divide-y divide-gray-900 border-y">
      <Accordion
        expandedItems={openedSection ? [openedSection] : []}
        onToggle={onAccordionItemToggle}
      >
        {reviewsSummary && (
          <AccordionItem id="reviews" isPreRendered={false}>
            <AccordionItemHeader>
              <div className="flex items-center space-x-2.5">
                <Heading as="h2" display="h2" title="Recenzii" />

                <Ratings
                  reviewsCount={reviewsCount}
                  ratingSummary={reviewsScore}
                  displayRatingScore={true}
                  displayIfEmpty={false}
                  productUrl={``}
                />

                {Boolean(reviewsScore) &&
                  Boolean(reviewsCount) &&
                  reviewsCount > 0 && (
                    <span className="align-middle inline-block text-2xl font-medium mx-10px lg:mr-7px">
                      {reviewAverage}
                    </span>
                  )}

                <span className="inline-block py-1 px-2 min-w-[30px] bg-yellow rounded-md text-sm leading-none align-middle text-center">
                  {reviewsCount > 0 ? reviewsCount : "0"}
                </span>
              </div>
            </AccordionItemHeader>

            <AccordionItemBody>
              <SellerReviews reviewsSummary={reviewsSummary} seller_id={id} />
            </AccordionItemBody>
          </AccordionItem>
        )}

        <AccordionItem id="descriere">
          <AccordionItemHeader>
            <Heading title="Descriere" />
          </AccordionItemHeader>

          <AccordionItemBody>
            <HtmlEmbed html={description || "Nu exista informatii"} />
          </AccordionItemBody>
        </AccordionItem>

        <AccordionItem id="politica-de-livrare">
          <AccordionItemHeader>
            <Heading title="Politica de livrare" />
          </AccordionItemHeader>

          <AccordionItemBody>
            <HtmlEmbed html={shipping_info || "Nu exista informatii"} />
          </AccordionItemBody>
        </AccordionItem>

        <AccordionItem id="politica-de-returnare">
          <AccordionItemHeader>
            <Heading title="Politica de returnare" />
          </AccordionItemHeader>

          <AccordionItemBody>
            <HtmlEmbed html={rma_info || "Nu exista informatii"} />
          </AccordionItemBody>
        </AccordionItem>

        <AccordionItem id="politica-de-garantie">
          <AccordionItemHeader>
            <Heading title="Politica de garantie" />
          </AccordionItemHeader>

          <AccordionItemBody>
            <HtmlEmbed html={warranty_info || "Nu exista informatii"} />
          </AccordionItemBody>
        </AccordionItem>

        <AccordionItem id="politica-de-confidentialitate">
          <AccordionItemHeader>
            <Heading title="Politica de confidentialitate" />
          </AccordionItemHeader>

          <AccordionItemBody>
            <HtmlEmbed
              html={customer_confidentiality_info || "Nu exista informatii"}
            />
          </AccordionItemBody>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default SellerTabs;
